export default function ChevronRight() {
    return (
        <svg
            width='8'
            height='13'
            viewBox='0 0 8 13'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M0.59 1.99838L5.17 6.58838L0.59 11.1784L2 12.5884L8 6.58838L2 0.588379L0.59 1.99838Z'
                fill='#67FF5A'
            />
        </svg>
    );
}
